import { Client } from 'mtm-ws-edge';
import { Edge as EdgeSync } from '../Syncs/Edge';

export class Edge extends Client
{
	protected _bypassObj=null;
	protected _bypassMethod=null;
	protected _syncObjs={};

	public constructor()
	{
		super();
		super.setIngressCb(this, "wsSyncIngress");
	}
	public terminate()
	{
		Object.keys(this._syncObjs).forEach((guid)=>{
			var syncObj	= this._syncObjs[guid];
			syncObj.terminate();
		});
		//make sure parent also terminates
		super.terminate();
	}
	public setIngressCb(obj=null, method=null)
	{
		if (typeof obj == "object" && typeof method == "string") {
			this._bypassObj		= obj
			this._bypassMethod	= method
		}
		return this;
	}
	public async wsSyncIngress(reqObj)
	{
		if (reqObj.getType() == "edge-ingress-request") {

			var msgObj	= reqObj.getRxData();
			if (
				typeof msgObj == "object"
				&& typeof msgObj["service"] == "string"
				&& msgObj["service"] == "MTM-WS-SYNC"
			) {

				try {
					var syncObj	= this.getSyncByGuid(msgObj.dstSync);
					if (syncObj !== null) {
						
						await syncObj.handleIngress(reqObj);
						reqObj.exec();
						
					} else {
						throw this.getAuto().newException("Invalid Sync: " + msgObj.dstSync);
					}
				} catch (e) {
					reqObj.setError(e).exec();
				}
						
			} else {
				//not a sync call pass through to the default handler
				this.callBypass(reqObj);
			}

		} else {
			//not a sync call pass through to the default handler
			this.callBypass(reqObj);
		}
	}
	public getSyncs()
	{
		return this._syncObjs;
	}
	public newSync()
	{
		var rObj		= new EdgeSync();
		rObj.setParent(this).setAuto(this.getAuto());
		this._syncObjs[rObj.getGuid()]	= rObj;
		return rObj;
	}
	public getSyncByGuid(guid)
	{
		if (typeof this._syncObjs[guid] != "undefined") {
			return this._syncObjs[guid];
		} else {
			return null;
		}
	}
	public removeSync(syncObj)
	{
		if (typeof this._syncObjs[syncObj.getGuid()] != "undefined") {
			delete this._syncObjs[syncObj.getGuid()];
		}
		return this;
	}
	public callBypass(reqObj)
    {
		if (this._bypassObj !== null) {
			this._bypassObj[this._bypassMethod](reqObj);
		}
    }
}